import stateExtender from '@/store/utils/stateExtender';
import RepositoryFactory from '@/services/repository-factory';
import datatableModule from '@/store/builder/datatableModule';
import table from '@/components/builders/configs/tables/transactionsTable';
import filters from '@/components/builders/configs/filters/transactionsFilters';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const transactionsRepository = RepositoryFactory.get('finances');
const state = {
  repository: transactionsRepository,
  error: null,
};

export default stateExtender({
  namespaced: true,
  state: () => state,
  modules: {
    table: datatableModule({
      fetch: transactionsRepository.transactionsTable,
      headers: table.headers.filter((header) => header.isShown),
      allHeaders: table.headers,
      options: {
        sortBy: ['id'],
        sortDesc: [true],
        itemsPerPage: 30,
      },
      search: filters,
    }),
  },
  getters,
  mutations,
  actions,
});
